<template>
  <div>
    <!-- masterBookに中身が入ったら描画されるテンプレート -->
    <TemplateMasterBook v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />

    <!-- なんらかが原因でURLが不正なページへのアクセスが発生した場合のダイアログ -->
    <DialogInvalidPageAccess ref="DialogInvalidPageAccess" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

// Vueファイル
import TemplateMasterBook from "@/views/Templates/TicketStore/TemplateMasterBook";
import DialogInvalidPageAccess from "@/views/Components/Organisms/TicketStore/Dialog/DialogInvalidPageAccess";

// Service
import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

import storeJS from "@/store";
import routerJS from "@/router";

// QRコードが読み込めず、救済コード画面へ遷移させるwindow関数→Vue内のredirectメソッドを実行
window.jcRedirectToOnetimeCode = function () {
  try {
    const route = routerJS.currentRoute._rawValue;

    // ワンタイム入力画面へのリダイレクト
    routerJS.push({
      name: "OneTiemCode",
      params: { id: route.params.id },
      query: { language: storeJS.getters["common/lang"] },
    });
  } catch (e) {
    console.log("Error in jcRedirectToOnetimeCode", e);
  }
};

export default {
  name: "MasterBook",
  components: {
    TemplateMasterBook: TemplateMasterBook,
    DialogInvalidPageAccess: DialogInvalidPageAccess,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isReadyToDraw = ref(false);
    const DialogInvalidPageAccess = ref(null);

    onMounted(async () => {
      try {
        nativeHandlerService.ncAppVersion();
        if (route.query.master_book_set_id) {
          // Get /master-book-sets でMasterBookSet情報取得
          await API.getMasterBookSet(route.query.master_book_set_id);
        } else {
          await API.getMasterBook(route.params.id);
        }
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "MasterBook onMounted()",
          JSON.stringify(err)
        );
        // 認証エラーの場合
        if (
          !err.response ||
          err.response.data.error == "internal_error" ||
          err.response.data.error == "parameter_error"
        ) {
          nativeHandlerService.returnNativeAppToAccountPage();
          // ダイアログを閉じたときのために、5秒後に一覧にリダイレクト
          setTimeout(() => {
            nativeHandlerService.returnNativeAppTopPage();
          }, 5000);
          return;
        }
        // 本番環境で端末時刻が不正の場合は、ネイティブで別途ダイアログ出す
        else if (err != "invalid client DateTime") {
          openDialogInvalidPageAccess();
        }
        console.log("error in MasterBook", err);
      }
    });

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    watchEffect(() => {
      if (masterBook.value.length !== 0) {
        isReadyToDraw.value = true;
      }
    });

    // URL不正の場合のダイアログ
    const openDialogInvalidPageAccess = () => {
      DialogInvalidPageAccess.value.openDialog();
    };

    return {
      isReadyToDraw,
      masterBook,
      DialogInvalidPageAccess,
    };
  },
};
</script>
